import React, { useCallback, useEffect, useState } from "react";
import ComboCouponExtensionsTab from "../Combo/ComboCouponExtensionsTab";
import ComboService from "../../services/ComboService";

const comboService = new ComboService();

const normalizeExtensionRequests = (payload: any) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.rows)) return payload.rows;
  return [];
};

const CustomerComboExtensionsTab = ({ userId }: { userId: number }) => {
  const [loading, setLoading] = useState(false);
  const [extensionRequests, setExtensionRequests] = useState<any[]>([]);

  const loadData = useCallback(async () => {
    if (!userId || Number.isNaN(userId)) {
      setExtensionRequests([]);
      return;
    }

    setLoading(true);
    try {
      const response = await comboService.getExpiryExtensionRequestsByUser(userId);
      setExtensionRequests(normalizeExtensionRequests(response));
    } catch (error) {
      setExtensionRequests([]);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <ComboCouponExtensionsTab
      extensionRequests={extensionRequests}
      isLoading={loading}
      onRefreshData={loadData}
      title="Customer Coupon Extensions"
    />
  );
};

export default CustomerComboExtensionsTab;
